import * as S from "./styles.ts";
import { AnimatePresence, motion } from "framer-motion";
import { Check } from "lucide-react";
import { ColorKey } from "@template/theme/types/color.type.ts";

export type TRadioBlobSize = "sm" | "md" | "lg";
export type TRadioBlobVariant = "check" | "radio" | "check-circle";

export interface IRadioBlobProps {
  selected?: boolean;
  disabled?: boolean;
  size?: TRadioBlobSize;
  variant?: TRadioBlobVariant;
  readOnly?: boolean;
  color?: ColorKey;
}

const RadioBlob = ({
  selected,
  disabled,
  size = "sm",
  variant = "check",
  readOnly,
  color = "primary",
}: IRadioBlobProps) => (
  <S.RadioBlob
    $selected={selected}
    $variant={variant}
    $disabled={disabled}
    $size={size}
    $readOnly={readOnly}
    $color={color}
  >
    <AnimatePresence>
      {selected && (
        <S.IconContainer
          as={motion.div}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
        >
          {["check", "check-circle"].includes(variant) ? (
            <Check />
          ) : (
            <S.Circle />
          )}
        </S.IconContainer>
      )}
    </AnimatePresence>
  </S.RadioBlob>
);

export default RadioBlob;
